import React, { useState, useEffect } from 'react';
import { authorQueryService } from '../../services/authorQueryService';
import { Icons } from '../common';
import './DatabaseStatusIndicator.css';

/**
 * Component to show if references and queries exist in database for an article
 */
const DatabaseStatusIndicator = ({ articleId, onStatusLoaded }) => {
  const [status, setStatus] = useState({
    hasReferences: false,
    hasQueries: false,
    queries: [],
    loading: true
  });

  useEffect(() => {
    if (articleId) {
      checkDatabaseStatus();
    }
  }, [articleId]);

  const checkDatabaseStatus = async () => {
    try {
      setStatus(prev => ({ ...prev, loading: true }));
      const dbStatus = await authorQueryService.checkDatabaseStatus(articleId);
      setStatus({
        hasReferences: dbStatus.hasReferences,
        hasQueries: dbStatus.hasQueries,
        queries: dbStatus.queries,
        loading: false
      });

      // Notify parent component
      if (onStatusLoaded) {
        onStatusLoaded(dbStatus);
      }
    } catch (error) {
      console.error('Error checking database status:', error);
      setStatus({
        hasReferences: false,
        hasQueries: false,
        queries: [],
        loading: false
      });
    }
  };

  if (status.loading) {
    return (
      <div className="db-status-indicator loading">
        <Icons.LoaderIcon className="spinning" />
        <span>Checking database...</span>
      </div>
    );
  }

  if (!status.hasReferences && !status.hasQueries) {
    return null; // Don't show anything if nothing exists in database
  }

  return (
    <div className="db-status-indicator">
      <div className="db-status-header">
        <Icons.DatabaseIcon />
        <span className="db-status-title">Database Status</span>
      </div>
      <div className="db-status-items">
        {status.hasReferences && (
          <div className="db-status-item success">
            <Icons.CheckCircleIcon />
            <span>References stored</span>
          </div>
        )}
        {status.hasQueries && (
          <div className="db-status-item warning">
            <Icons.ExclamationTriangleIcon />
            <span>{status.queries.length} {status.queries.length === 1 ? 'query' : 'queries'} found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DatabaseStatusIndicator;

